export const SET_ACTIVE_SECTION = 'ProductCatalog::SetActiveSection';
export const SET_CATALOG_PRODUCT_OFFICES = 'ProductCatalog::SetHoveredProductData::Offices';
export const UNSET_CATALOG_PRODUCT_OFFICES = 'ProductCatalog::ClearHoveredProductData::Offices';
export const SET_CATALOG_PRODUCT_HOVERED_ID = 'ProductCatalog::SetHoveredProductData::ProductId';
export const SET_CATALOG_PRODUCT_HOVERED_TITLE =
  'ProductCatalog::SetHoveredProductData::ProductTitle';
export const CATALOG_PRODUCT_DESCRIPTION_PLATE = 'вы сможете получить по адресу ';

export const SET_DELIVERY_ACTIVE_SECTION = 'ProductCatalog::SetTakeawayActiveSection';
export const SET_DELIVERY_TAKEAWAY_VIEW = 'ProductCatalog::SetTakeawayView';
export const SET_DELIVERY_POINTS_VIEW = 'ProductCatalog::SetView::PointsView';
export const SET_DELIVERY_TAKEAWAY_SEARCH_QUERY = 'ProductCatalog::SetTakeawaySearchQuery';
export const SET_DELIVERY_ACTIVE_POINT = 'ProductCatalog::SetTakeawayActivePoint';

export const DELIVERY_TAKEAWAY_OPEN = 'ProductCatalog::Takeaway::OpenState';
export const DELIVERY_TAKEAWAY_VIEW = 'ProductCatalog::Takeaway::ViewState';
export const DELIVERY_TAKEAWAY_SUCCESS = 'ProductCatalog::Takeaway::Success';
export const DELIVERY_TAKEAWAY_LOADING = 'ProductCatalog::Takeaway::Loading';
export const DELIVERY_TAKEAWAY_ERROR_DETAILS = 'ProductCatalog::Takeaway::ErrorDetails';
export const REQUEST_CATALOG_PRODUCT_OFFICES_ERROR = 'ProductCatalog::Takeaway::ErrorDetails';
export const SET_INITIAL_CATALOG_DELIVERY_OFFICES = 'ProductCatalog::Takeaway::SetInitialOffices';
export const SET_DELIVERY_TAKEAWAY_FILTERS = 'ProductCatalog::Takeaway::SetTakeawayFilters';
export const SET_DELIVERY_TAKEAWAY_FILTER_OPTION =
  'ProductCatalog::Takeaway::SetTakeawayFilterOption';

export const SET_DELIVERY_TAKEAWAY_ACTIVE_BUTTON =
  'ProductCatalog::Takeaway::SetDeliveryActiveButton::Slug';
export const SET_DELIVERY_TAKEAWAY_SORT_DIRECTION =
  'ProductCatalog::Takeaway::SetDeliverySort::Direction';
export const SET_DELIVERY_TAKEAWAY_POINTS_TO_SHOW =
  'ProductCatalog::Takeaway::SetDelivery::PointsToShow';
export const HIDE_DELIVERY_TAKEAWAY_POINTS_TO_SHOW =
  'ProductCatalog::Takeaway::SetDelivery::HidePointsToShow';

export const REQUEST_AGREEMENT_CONTENT = 'ProductCatalog::Takeaway::Loading::Agreement';
export const REQUEST_AGREEMENT_CONTENT_SUCCESS = 'ProductCatalog::Takeaway::Success::Agreement';
export const REQUEST_AGREEMENT_CONTENT_FAIL = 'ProductCatalog::Takeaway::Error::Agreement';

export const REQUEST_PROPS_CONTENT = 'ProductCatalog::Takeaway::Loading::Props';
export const REQUEST_PROPS_CONTENT_SUCCESS = 'ProductCatalog::Takeaway::Success::Props';
export const REQUEST_PROPS_CONTENT_FAIL = 'ProductCatalog::Takeaway::Error::Props';

export const DELIVERY_TAKEAWAY_POINTS_SHOW_COUNT = 5;

export const DELIVERY_TAKEAWAY_OFFICE = 'op';

export const CATALOG_TAKEAWAY_VIEW_LIST = 'list';
export const CATALOG_TAKEAWAY_VIEW_MAP = 'map';

export const CATALOG_POINT_SORT_DATE = 'date';
export const CATALOG_POINT_SORT_METRO = 'metro';
export const CATALOG_POINT_SORT_ADDR = 'address';

export const CATALOG_POINT_GTM_VIEW_MAP = 'Карта';
export const CATALOG_POINT_GTM_VIEW_LIST_SORT_METRO = 'Метро';
export const CATALOG_POINT_GTM_VIEW_LIST_SORT_ADDR = 'Адрес';
export const CATALOG_POINT_GTM_VIEW_LIST_SORT_DATE = 'Дата';
